// extracted by mini-css-extract-plugin
module.exports = {"additionalInfo":"AdditionalInfoElement_additionalInfo__ghs1E"};